import { useMemo } from 'react';
import { useMutation, useQuery } from 'convex/react';
import { api } from '@aeon-karaoke/cloud-convex';
import type { Id } from '@aeon-karaoke/cloud-convex/_generated/dataModel';
import { useCurrentUser } from './useCurrentUser';

/** The caller's private favourites, shared by every screen that draws a star.
 * The toggle applies optimistically so the star fills with its pulse rather
 * than after the round trip. */
export function useFavourites() {
  const { user } = useCurrentUser();
  const ids = useQuery(api.favorites.mine, user ? {} : 'skip');
  const toggleFavourite = useMutation(api.favorites.toggle).withOptimisticUpdate((store, { trackId }) => {
    const current = store.getQuery(api.favorites.mine, {});
    if (!current) return;
    store.setQuery(
      api.favorites.mine,
      {},
      current.includes(trackId) ? current.filter((id) => id !== trackId) : [...current, trackId]
    );
  });

  const favourites = useMemo(() => new Set(ids ?? []), [ids]);
  return { favourites, toggle: (trackId: Id<'tracks'>) => void toggleFavourite({ trackId }) };
}
